import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ProductTypes } from '../model/product/product-type';
import { FilterStoreService } from './filter-store.service';

@Injectable({
  providedIn: 'root'
})
export class ProductTypeCriteriumService {
  private selectedTypeOptions: any[];
  private typeCriteriumChanged = new Subject<any[]>();
  private readonly windowStickerOptions = [
    ProductTypes.WINDOWSTICKER.value,
    ProductTypes.CUSTOMWINDOWSTICKER.value
  ];

  constructor(private filterStoreService: FilterStoreService) {
    this.selectedTypeOptions = filterStoreService.getTypeOptions(
      this.getTypeStoreKey()
    );
  }

  public getTypeCriteriumChangedSubscribable() {
    return this.typeCriteriumChanged;
  }

  private getTypeStoreKey() {
    return 'ProductTypeCriteriumService';
  }

  public getSelectedTypeOptions() {
    return this.selectedTypeOptions;
  }

  public selectedTypeOptionsChange(selectedTypeOptions: any[]) {
    this.selectedTypeOptions = selectedTypeOptions;
    this.filterStoreService.setTypeOptions(
      this.getTypeStoreKey(),
      this.selectedTypeOptions
    );
    this.typeCriteriumChanged.next(this.selectedTypeOptions);
  }

  public generateTypeCriteriumParam() {
    const selectedTypeOptions = this.getSelectedTypeOptions();
    return selectedTypeOptions != null && selectedTypeOptions.length > 0
      ? [
          {
            key: 'typeCriteria',
            value: JSON.stringify({
              typeCriteria: {
                project__products: this.stringifySelectedTypeOptions(
                  selectedTypeOptions
                )
              }
            })
          }
        ]
      : null;
  }

  private stringifySelectedTypeOptions(selectedTypeOptions: any[]): string[] {
    const toReturn = [];
    for (const typeOption of selectedTypeOptions) {
      if (typeOption === 'WindowSticker') {
        toReturn.push(...this.windowStickerOptions);
      } else {
        toReturn.push(typeOption);
      }
    }
    return toReturn;
  }
}
